<div class="footer-pages wrap container-fluid">
  <h1>Contact Us</h1>
  <h2><a href="">contact&commat;journeyal.com</a></h2>
</div>